export enum EMappedOn {
    ASSIGNMENT_KEY = 'ASSIGNMENT_KEY',
    USER_FIELD = 'USER_FIELD',
}

export enum EUserSyncAction {
    KEEP = 'KEEP',
    KEEP_PUBLIC = 'KEEP_PUBLIC',
    REMOVE = 'REMOVE',
    NEW_ASSIGNMENT_KEY = 'NEW_ASSIGNMENT_KEY'
}

export enum EAssignmentKeyStatus {
    USED = 'USED', // 'EAssignmentKeyStatus'
    ACTIVE = 'ACTIVE', // Assignment key already exists and active, please check
    NOT_EXIST = 'NOT_EXIST', // 'No Match found'
    REACTIVATED = 'REACTIVATED', //
}
